import { reduxForm } from 'redux-form'
import at from 'lodash/at'
import get from 'lodash/get'

import { goBack } from 'react-router-redux'
import { fetchContractsForLocation } from '../../actions/contracts'
import { setContractFilterForLocation } from '../../actions/work-tracker-filters'

import WorkTrackerFilterModal from '../../components/work-trackers/work-tracker-filter-modal'

const fields = [
  'resourceId'
]

function mapStateToProps (state, ownProps) {
  const id = ownProps.params.locationId
  const location = state.locations[id]

  const resources = at(state.contracts, location.contracts || [])

  return {
    resourceName: 'contract',
    modalTitle: 'Choose a Contract',
    initialValues: {
      resourceId: get(state, `workTrackerFilters.${id}.contractId`)
    },
    resources,
    resourceNameGenerator: (contract) =>
      `${contract.startDate.format('MMM Do, YYYY')} – ${contract.endDate.format('MMM Do, YYYY')}`
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.params.locationId

  dispatch(fetchContractsForLocation(id))

  return {
    handleClose () {
      dispatch(goBack())
    },

    onSubmit (data) {
      dispatch(setContractFilterForLocation(id, data.resourceId))
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'filterContract'
  },
  mapStateToProps,
  mapDispatchToProps
)(WorkTrackerFilterModal)



// WEBPACK FOOTER //
// ./src/containers/work-trackers/work-tracker-contract-filter-container.js